<template>
  <div class="header-container">
    <div class="header-box">
       <div class="logo">
        <img src="./logo.svg" alt="" srcset="" />
        <h1>Introduction to Engineering for Electronic Information (B)</h1>
      </div>
      <ul class="router-list">
        <li
          class="router-item"
          :class="{ active: item.name === $route.name }"
          v-for="item in routerList"
          :key="item.name"
          @click="routerPush(item)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routerList: [
        {
          name: "Home",
          label: "Home",
        },
        {
          name: "Syllabus",
          label: "Syllabus",
        },
        {
          name: "Projects",
          label: "Projects",
        },
      ],
    };
  },
  methods: {
    routerPush(item) {
      this.$router.push({
        name: item.name,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header-container {
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  font-family: Source Sans Pro;
  .header-box {
    width: 1420px;
    height: 64px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    img {
      vertical-align: middle;
    }
    h1 {
      display: inline-block;
      margin: 0;
      margin-left: 16px;
      font-weight: 900;
      font-size: 20px;
      color: #000000;
    }
  }
  .router-list {
    .router-item {
      display: inline-block;
      margin-left: 48px;
      cursor: pointer;
      &.active {
        font-weight: 900;
      }
    }
  }
}
</style>
